import { render } from "./RefundBlock.vue?vue&type=template&id=299b1530"
import script from "./RefundBlock.vue?vue&type=script&lang=js"
export * from "./RefundBlock.vue?vue&type=script&lang=js"
script.render = render

export default script